import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { UpdateNoteInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const UpdateNoteMutation = graphql(`
  mutation UpdateNote($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      id
      clientId
      meetingId
      content
      title
      createdAt
      updatedAt
      summary
      openTodosCount
      __typename
    }
  }
`);

export function useUpdateNote() {
  const [result, updateNoteMutation] = useMutation(UpdateNoteMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateNote = useCallback(
    async (input: UpdateNoteInput) => {
      try {
        const response = await updateNoteMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.updateNote;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [updateNoteMutation],
  );

  return { updateNote, result, error };
}
